import { Component, ErrorHandler, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TripSearchService } from '../../core/services/trip-search.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddBookingModel } from '../../core/interfaces/add-booking.interface';
import { BaseService } from '../../core/services/base.service';
import { SnackbarService } from '../../core/services/snackbar.service';
import { ToastService } from '../../core/services/toast.service';
import { ConfigService } from '../../core/services/config.service';
import { ChangeDetectorRef } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { PlatformLocation } from '@angular/common';
import { ClientDetailsModel } from '../../models/ClientDetails';
import { catchError, map } from 'rxjs';


declare let Razorpay: any;

@Component({
  selector: 'app-booking-details',
  imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './booking-details.html',
  styleUrl: './booking-details.scss'
})
export class BookingDetails implements OnInit {
  private readonly platformLocation = inject(PlatformLocation);

  // UI State
  showGstDetails = false;
  isMobile = false;
  showCostBreakdown = false;
  termsAccepted = false;
  showAdditionalDetails = false;
  costBreakdownVisible = false;
  showPassengerCountError = false;
  showNameError = false;
  showMobileError = false;
  showPickupAddressError = false;
  showDropAddressError = false;
  showcheckboxError = false;
  showGstNumberError = false;
  selectedPaymentOption = '100';
  defaultCompanyName: string = '';
  defaultCompanyLogo: string = '';


  
  readonly GST_NUMBER_PATTERN = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

 
  form!: FormGroup;
  addBookingModel!: AddBookingModel;
  Address?: string;
  dropAddress?: string;
  bookingDetailsModel: any = {};
  userDetails: any = {};

  
  isBookingLoading = false;
  bookingSuccess = false;
  loadingSpinner = false;
  bookingMessage: any = { Status: '', Message: '' };

  
  bookingData: any = {
    clientName: '',
    clientId: 0,
    servingCityId: 0,
    poDetailsId: 0,
    orderId: '',
    paymentId: '',
    vehicleName: '',
    vehicleImage: '',
    package: '',
    servingCity: '',
    numberOfBags: 0,
    numberOfDays: 0,
    seatingCapacity: 0,
    basicHours: 0,
    date: '',
    basicKms: 0,
    time: '',
    parkingCharges: '',
    tollCharges: '',
    additionalDetails: '',
    packageAmount: 0,
    taxAmount: 0,
    totalFare: 0,
    extraPerKm: 0,
    extraHrs: 0,
    noOfBags: 0,
    noOfDays: 0,
    toatlTaxAmt: 0,
    cgst: 0,
    sgst: 0,
    cgstAmount: 0,
    sgstAmount: 0,
    pay50Amount: 0,
    pay100Amount: 0,
    isPerBookingAmt: 0,
  };


  RAZORPAY_OPTIONS: any = {
    key: '',  //environment.razorPayKey,
    amount: '',
    name: 'MyFleetMan',
    order_id: '',
    description: '',
    image: 'https://myfleetman.in/img/MyFleetMan.png',
    callback_url: '',
    redirect: true,
    callback_method: 'get',
    prefill: {
      name: this.userDetails.name,
      email: this.userDetails.emailId,
      contact: this.userDetails.mobileNumber,
      method: '',
    },
    modal: {
      escape: false,
    },
    theme: {
      hide_topbar: true,
      color: '#7bbf58',
    },
  };
  clientDetails: ClientDetailsModel = new ClientDetailsModel();

  constructor(
    private tripSearchService: TripSearchService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private fb: FormBuilder,
    private baseService: BaseService,
    private snackbarService: SnackbarService,
    private toastService: ToastService,
    private snackBar: MatSnackBar,
    private configService: ConfigService,
    private cd: ChangeDetectorRef,
    private authService: AuthService
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.initializeBookingData();
    this.setupResponsiveObserver();
    this.loadRazorpayScript();
    this.loadUserDetails();
    this.GetClient();
    this.initializeRazorpayOptions();

  }



  GetClient() {
    const apiUrl = `/api/B2COnlineBooking/B2CclientDetails`;

    debugger;
    this.baseService.getData(apiUrl).pipe(
      map((response: any) => {
        if (response.responseCode === 'OK') {
          debugger;
          this.clientDetails = response.data as ClientDetailsModel;
          this.defaultCompanyName = this.clientDetails.defaultCompanyName;
          this.defaultCompanyLogo = this.clientDetails.defaultCompanyLogo;
          return response.data as ClientDetailsModel[];
        } else {
          throw new Error(response.responseMessage);
        }
      }),
    ).subscribe({
      next: (data) => { },
      error: (error) => { }
    });
  }




  private initializeRazorpayOptions() {
    
    const config = this.configService.readConfig();
    this.RAZORPAY_OPTIONS.key = config.razorPayKey;
  
    this.configService.loadSysConfig(this.platformLocation).subscribe(updatedConfig => {
      if (updatedConfig && updatedConfig.razorPayKey && updatedConfig.razorPayKey !== config.razorPayKey) {
        this.RAZORPAY_OPTIONS.key = updatedConfig.razorPayKey;
        
      }
    });
  }

  private loadUserDetails() { 
    const currentUser = this.authService.getCurrentUser();
    if (currentUser) {
      this.userDetails = {
        ...this.userDetails,
        name: `${currentUser.firstName} ${currentUser.lastName}`.trim(),
        mobileNumber: String(currentUser.phone || ''),
        emailId: currentUser.email || ''
      };

      // Update form controls
      this.form.patchValue({
        name: this.userDetails.name,
        mobileNumber: this.userDetails.mobileNumber,
        emailAddress: this.userDetails.emailId
      });
    }
  }

  private initializeForm() {
    this.form = this.fb.group({
      mobileNumber: ['', Validators.required],
      name: ['', Validators.required],
      noofPassengers: [0, Validators.required],
      emailAddress: ['', [Validators.required, Validators.email]],
      pickUpAddress: ['', Validators.required],
      dropAddress: ['', Validators.required],
      address: [''],
      gstNnumber: [''],
      billingName: ['']
    });
  }

  // Method to manually trigger data update (can be called from parent or service)
  public refreshBookingData() {
    this.initializeBookingData();
  }

  private initializeBookingData() {
    const selectedPackage = this.tripSearchService.getSelectedPackage();
    const searchFormData = this.tripSearchService.getSearchFormData();
    

    if (searchFormData) {
      this.updateBookingDataFromSearchForm(searchFormData);
    }

    if (selectedPackage) {
     
      this.updateBookingDataFromSelectedPackage(selectedPackage);
    } else {
     
    }

    this.logServiceData();
  }

  private setupResponsiveObserver() {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  private loadRazorpayScript() {
    
    if (typeof Razorpay !== 'undefined') {
      return;
    }

    const config = this.configService.readConfig();
    const script = document.createElement('script');
    script.src = config.razorpayUrl || 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => {
      
    };
    script.onerror = () => {
      console.error('Failed to load Razorpay script from:', script.src);
    };
    document.head.appendChild(script);
  }

  updateBookingDataFromSelectedPackage(selectedPackage: any) {
    if (selectedPackage) {
      this.bookingData = { ...this.bookingData, ...selectedPackage };
      
    }
  }

  updateBookingDataFromSearchForm(searchFormData: any) {
    debugger;
    if (searchFormData) {
      

      if (searchFormData.startDate) {
        const startDate = new Date(searchFormData.startDate);
        const day = startDate.getDate().toString().padStart(2, '0');
        const month = startDate.toLocaleDateString('en-US', { month: 'short' });
        const year = startDate.getFullYear();
        this.bookingData.date = `${day}-${month}-${year}`;
      }
      if (searchFormData.endDate) {
        const endDate = new Date(searchFormData.endDate);
        const day = endDate.getDate().toString().padStart(2, '0');
        const month = endDate.toLocaleDateString('en-US', { month: 'short' });
        const year = endDate.getFullYear();
        this.bookingData.ToTime = `${day}-${month}-${year}`;
      }


      if (searchFormData.pickupTime) {
        this.bookingData.time = searchFormData.pickupTime;
      }
      if (searchFormData.cityName) {
        this.bookingData.servingCity = searchFormData.cityName;
      }
      if (searchFormData.cityId) {
        this.bookingData.servingCityId = searchFormData.cityId;
      }

      // Extract client information from search criteria
      if (searchFormData.clientId) {
        this.bookingData.clientId = searchFormData.clientId;
      }
      if (searchFormData.clientName) {
        this.bookingData.clientName = searchFormData.clientName;
      }

    }
  }

  toggleGstDetails() {
    this.showGstDetails = !this.showGstDetails;
  }

  toggleAdditionalDetails(event: Event) {
    event.preventDefault();
    this.showAdditionalDetails = !this.showAdditionalDetails;
  }

  formatAdditionalContent(content: string): string {
    if (!content) return '';

    // Clean and format the content - just handle line breaks properly
    let formattedContent = content
      .replace(/<br\s*\/?>/gi, '<br>')
      .replace(/<br>/g, '</div><div class="pricing-text">')
      .replace(/<strong>/g, '<strong>')
      .replace(/<\/strong>/g, '</strong>');

    if (!formattedContent.startsWith('<div')) {
      formattedContent = `<div class="pricing-text">${formattedContent}</div>`;
    }

    return formattedContent;
  }

  onContinue() {
    this.showCostBreakdown = true;
  }

  onBack() {
    this.showCostBreakdown = false;
  }

  goBackToSearch() {
    // Navigate back to booking search
    window.history.back();
  }

  goBackToUserDetails() {
    this.costBreakdownVisible = false;

    
    const costBreakdownSection = document.querySelector('.cost-breakdown-section');
    if (costBreakdownSection) {
      costBreakdownSection.classList.remove('show-cost-breakdown');
    }

    
    const carDetailsSection = document.querySelector('.car-details-section');
    if (carDetailsSection) {
      carDetailsSection.classList.remove('hide-on-mobile');
    }

    
    const userDetailsSection = document.querySelector('.user-details-section');
    if (userDetailsSection) {
      userDetailsSection.classList.remove('hide-on-mobile');
    }

    
    const mobileNavButtons = document.querySelector('.mobile-navigation-buttons');
    if (mobileNavButtons) {
      mobileNavButtons.classList.remove('hide-on-mobile');
    }

   
    const mobileCostBreakdownHeader = document.querySelector('.mobile-cost-breakdown-header');
    if (mobileCostBreakdownHeader) {
      mobileCostBreakdownHeader.classList.remove('show-on-mobile');
    }

    
    const mainHeader = document.querySelector('.header');
    if (mainHeader) {
      mainHeader.classList.remove('hide-on-mobile');
    }
  }

  
  navigateToTerms() {
    this.router.navigate(['/terms']);
  }

  navigateToCancellation() {
    this.router.navigate(['/cancellation']);
  }

  navigateToPrivacy() {
    this.router.navigate(['/privacy']);
  }

  showCostBreakdownOnMobile() {

    if (!this.validateRequiredFields(false)) {
      return;
    }

    this.costBreakdownVisible = true;
    
    const costBreakdownSection = document.querySelector('.cost-breakdown-section');
    if (costBreakdownSection) {
      costBreakdownSection.classList.add('show-cost-breakdown');
    }

    
    const carDetailsSection = document.querySelector('.car-details-section');
    if (carDetailsSection) {
      carDetailsSection.classList.add('hide-on-mobile');
    }

   
    const userDetailsSection = document.querySelector('.user-details-section');
    if (userDetailsSection) {
      userDetailsSection.classList.add('hide-on-mobile');
    }

   
    const mobileNavButtons = document.querySelector('.mobile-navigation-buttons');
    if (mobileNavButtons) {
      mobileNavButtons.classList.add('hide-on-mobile');
    }

    
    const mobileCostBreakdownHeader = document.querySelector('.mobile-cost-breakdown-header');
    if (mobileCostBreakdownHeader) {
      mobileCostBreakdownHeader.classList.add('show-on-mobile');
    }

    // Hide main header
    const mainHeader = document.querySelector('.header');
    if (mainHeader) {
      mainHeader.classList.add('hide-on-mobile');
    }


  }

  // Form submission methods
  onPayLater() {
   
    if (!this.validateRequiredFields(true)) {
      return;
    }

    debugger;

    this.isBookingLoading = true;
    this.createBookingModel();

          if(this.addBookingModel.emailId == null || this.addBookingModel.emailId == ""){
              this.addBookingModel.emailId = this.userDetails.emailId
          }
   
    const apiUrl = '/api/B2COnlineBooking/AddBooking';

    this.baseService.postData(apiUrl, this.addBookingModel).subscribe({
      next: (response: any) => {
        debugger;
        this.isBookingLoading = false;
        this.cd.detectChanges();
        if (response.responseCode == "OK") {
          const bookingRefNo = response.data?.bookingRefNo || 'B2518112';
          this.toastService.success(`Your booking is saved with booking reference number = ${bookingRefNo}`, 'Booking Info');
          setTimeout(() => {
            this.router.navigate(['/home']);
          }, 3000);
        } else {
          this.toastService.error('Booking failed. Please try again.', 'Booking Error');
        }
      },
      error: (error: any) => {
        debugger;

        this.isBookingLoading = false;
        this.cd.detectChanges();
        if (error.status === 400) {

          this.toastService.info(error.error.responseMessage || 'Booking request could not be processed', 'Booking Info');
        } else {
          this.toastService.error('Error creating booking. Please try again.', 'Booking Error');
        }
      }
    });
  }

  onPayNow() {
    if (!this.validateRequiredFields(true)) {
      return;
    }

    this.isBookingLoading = true;
    this.createBookingModel();

    this.ensureRazorpayLoaded().then(() => {
      this.proceedWithPayment();
    }).catch((error) => {
      this.isBookingLoading = false;
      this.snackbarService.openSnackBarError('Payment gateway is not available. Please try again later.');
    });
  }

  private ensureRazorpayLoaded(): Promise<void> {
    return new Promise((resolve, reject) => {

      if (typeof Razorpay !== 'undefined') {
        resolve();
        return;
      }

      
      let attempts = 0;
      const maxAttempts = 100; 

      const checkRazorpay = () => {
        attempts++;
        if (typeof Razorpay !== 'undefined') {
          resolve();
        } else if (attempts >= maxAttempts) {
          reject(new Error('Razorpay failed to load within timeout'));
        } else {
          setTimeout(checkRazorpay, 100);
        }
      };

      checkRazorpay();
    });
  }

  private proceedWithPayment() {
    let returnOrderId: string;
    let amount = 0;
    const activetab = this.selectedPaymentOption;
    if (activetab == '50') {
      amount = this.percentageAmount;
    } else {
      amount = this.fullAmount;
    }
    let record = {
      razorPayAmount: (amount * 100).toString(),
      notes: 'string',
    };
    const apiUrlRazorPay = '/api/Razorpay/B2CCreateOrderId';
    this.baseService.postData(apiUrlRazorPay, record).subscribe({
      next: (response: any) => {

        if (response.responseCode == "OK") {
          returnOrderId = response.data?.orderId;
          this.createBookingModel();
          if(this.addBookingModel.emailId == null || this.addBookingModel.emailId == ""){
              this.addBookingModel.emailId = this.userDetails.emailId
          }
          if(this.addBookingModel.payNow == 0 || this.addBookingModel.payNow == null){
              this.addBookingModel.payNow =1;
          }else{
            this.addBookingModel.payNow =1;
          }

          this.addBookingModel.orderId = returnOrderId;
          this.addBookingModel.paymentId = returnOrderId;
          const apiUrl = '/api/B2COnlineBooking/AddBooking';

          this.baseService.postData(apiUrl, this.addBookingModel).subscribe({
            next: (response: any) => {
             

              let OrderId = response.data?.bookingId;
              this.RAZORPAY_OPTIONS.order_id = returnOrderId;
              this.RAZORPAY_OPTIONS.amount = (amount * 100).toString();

              this.RAZORPAY_OPTIONS.name = this.defaultCompanyName == '' ? 'MyFleetMan-B2C' : this.defaultCompanyName;
              this.RAZORPAY_OPTIONS.image = this.defaultCompanyLogo == undefined ? 'https://myfleetman.in/img/MyFleetMan.png' : this.defaultCompanyLogo;

              this.RAZORPAY_OPTIONS.prefill.email = this.addBookingModel.emailId;
              this.RAZORPAY_OPTIONS.prefill.contact = this.addBookingModel.customerMobileNo;
              const config = this.configService.readConfig();

              
              this.RAZORPAY_OPTIONS.callback_url = config.baseUrl +
                '/api/B2COnlineBooking/RazorPayCallBackUrlForConfirmBooking?bookingid=' +
                OrderId +
                '&AdavanceAmount=' +
                amount;
              
              // Debug logging
              console.log('Razorpay Options:', {
                key: this.RAZORPAY_OPTIONS.key,
                order_id: this.RAZORPAY_OPTIONS.order_id,
                amount: this.RAZORPAY_OPTIONS.amount,
                callback_url: this.RAZORPAY_OPTIONS.callback_url,
                bookingId: OrderId
              });
              this.RAZORPAY_OPTIONS.handler = this.razorPaySuccessHandler.bind(this);
              this.RAZORPAY_OPTIONS.modal.ondismiss = () => {
                this.isBookingLoading = false;
                this.loadingSpinner = false;
                this.cd.detectChanges();
              };

              // Validate Razorpay options before proceeding
              if (!this.RAZORPAY_OPTIONS.key) {
                console.error('Razorpay key is not set');
                this.snackbarService.openSnackBarError('Payment configuration error. Please try again.');
                this.isBookingLoading = false;
                return;
              }

              if (!OrderId) {
                console.error('Booking ID is not available');
                this.snackbarService.openSnackBarError('Booking creation failed. Please try again.');
                this.isBookingLoading = false;
                return;
              }

              // Razorpay should be available at this point since we checked in ensureRazorpayLoaded()
              try {
                let razorpay = new Razorpay(this.RAZORPAY_OPTIONS);

                razorpay.on('payment.failed', function (response: any) {
                  let errorMessage = 'Payment Fail \r\n' +
                    response.error.code + ' : ' + response.error.description
                  ', \r\n' + response.error.source;
                  ', \r\n' + response.error.step;
                  ', \r\n' + response.error.reason;
                  ', \r\n' + response.error.metadata.order_id;
                  ', \r\n' + response.error.metadata.payment_id;

                  alert(errorMessage);
                });
                razorpay.open();
              } catch (error) {
                console.error('Error initializing Razorpay:', error);
                this.snackbarService.openSnackBarError('Payment gateway error. Please try again later.');
                this.isBookingLoading = false;
              }
            },
            error: (error: any) => {
              this.isBookingLoading = false;
              this.cd.detectChanges();
              if (error.status === 400) {
                this.toastService.info(error.error.responseMessage || 'Booking request could not be processed', 'Booking Info');
              } else {
                this.toastService.error('Error creating booking. Please try again.', 'Booking Error');
              }
            }
          });
        }
        else {
          this.isBookingLoading = false;
          this.snackbarService.openSnackBarError(response['responseMessage'] || 'Failed to create payment order');
        }
      },
      error: (error: any) => {
        this.isBookingLoading = false;
        this.cd.detectChanges();
        if (error.status === 400) {

          this.toastService.info(error.error.responseMessage || 'Booking request could not be processed', 'Booking Info');
        } else {

          this.toastService.error('Error creating booking. Please try again.', 'Booking Error');
        }
      }
    });
    
  }

  onPay50Percent() {
    this.selectedPaymentOption = '50';
  }

  onPay100Percent() {
    this.selectedPaymentOption = '100';
  }

  
  calculatePercentageAmount(): number {
    const percentage = this.bookingData.isPerBookingAmt || 0;
    const totalFare = this.bookingData.totalFare || 0;
    return (totalFare * percentage) / 100;
  }

  calculateFullAmount(): number {
    return this.bookingData.totalFare || 0;
  }

  
  get percentageAmount(): number {
    return this.calculatePercentageAmount();
  }

  get fullAmount(): number {
    return this.calculateFullAmount();
  }


  
  isFormValid(): boolean {
    return !!(
      this.userDetails.name &&
      this.userDetails.mobileNumber &&
      this.userDetails.emailId &&
      this.userDetails.Address &&
      this.userDetails.dropAddress &&
      this.termsAccepted
    );
  }

 
  validateGstNumber(gstNumber: string): boolean {
    if (!gstNumber || gstNumber.trim() === '') {
      return false;
    }
    return this.GST_NUMBER_PATTERN.test(gstNumber.trim().toUpperCase());
  }

  
  logServiceData() {
    
  }


  createBookingModel() {
    this.addBookingModel = {
      customerMobileNo: this.userDetails.mobileNumber,
      customerName: this.userDetails.name,
      noofguests: this.userDetails.noofPassengers,
      emailId: this.userDetails.emailAddress,
      address: this.userDetails.Address,
      dropAddress: this.userDetails.dropAddress,
      clientName: this.bookingData.clientName,
      clientId: this.bookingData.clientId,
      fromTime: this.bookingData.date,
      toTime: this.bookingData.ToTime,
      time: this.bookingData.time,
      paymentMode: 1,
      isAdd: true,
      GSTNAddress: this.userDetails.billingPickupAddress,
      GSTNNumber: this.userDetails.gstNumber,
      GSTNBillingName: this.userDetails.billingName,
      isPayLater: true,
      totalFare: this.bookingData.totalFare,
      billingAmount: this.bookingData.totalFare,
      servingCityId: this.bookingData.servingCityId,
      poDetailsId: this.bookingData.poDetailsId,
      orderId: this.bookingData.orderId,
      paymentId: this.bookingData.paymentId,
      payNow: 0
    };

  }

  

  public razorPaySuccessHandler(response: any) {
    let razorpayResponseModel: any = JSON.parse(JSON.stringify(response));
    this.addBookingModel.paymentId = razorpayResponseModel.razorpay_payment_id;
    this.SaveRazorPayBooking();
  }

  SaveRazorPayBooking() {
    const apiUrl = '/api/B2COnlineBooking/AddBooking';
    this.baseService.postData(apiUrl, this.addBookingModel).subscribe({
      next: (res: any) => {
        this.bookingSuccess = true;

        if (res.responseCode == 'OK') {
          let orderId = res.data.bookingId;
          let Message = 'Your booking is Confirmed with Booking Id = ' + res.data.transactionId;
          this.bookingMessage.Status = 'Success';
          this.bookingMessage.Message = Message;
          this.cd.detectChanges();
        } else {
          this.bookingMessage.Status = 'Error:';
          this.bookingMessage.Message = res.responseMessage;
          this.cd.detectChanges();
        }
      },
      error: (err: any) => {
        this.bookingMessage.Status = 'Error';
        this.bookingMessage.Message = err.error.responseMessage;
        this.bookingSuccess = true;
        this.cd.detectChanges();
      }
    });
  }

  // Validate all required fields
  private validateRequiredFields(isValidate: boolean): boolean {
    let hasError = false;

    if (!this.userDetails.name || this.userDetails.name.trim() === '') {
      this.showNameError = true;
      hasError = true;
    }

    if (!this.userDetails.mobileNumber || this.userDetails.mobileNumber.trim() === '') {
      this.showMobileError = true;
      hasError = true;
    }

    if (!this.userDetails.passengersCount || this.userDetails.passengersCount <= 0) {
      this.showPassengerCountError = true;
      hasError = true;
    }

    if (!this.userDetails.Address || this.userDetails.Address.trim() === '') {
      this.showPickupAddressError = true;
      hasError = true;
    }

    if (!this.userDetails.dropAddress || this.userDetails.dropAddress.trim() === '') {
      this.showDropAddressError = true;
      hasError = true;
    }
    if (!this.termsAccepted && isValidate) {
      this.showcheckboxError = true;
      hasError = true;
    }

    if (this.showGstDetails) {
      if (!this.userDetails.gstNumber || this.userDetails.gstNumber.trim() === '') {
        this.showGstNumberError = true;
        hasError = true;
      } else if (!this.validateGstNumber(this.userDetails.gstNumber)) {
        this.showGstNumberError = true;
        hasError = true;
      }
    }

    if (hasError) {
      return false;
    }

   
    this.showNameError = false;
    this.showMobileError = false;
    this.showPassengerCountError = false;
    this.showPickupAddressError = false;
    this.showDropAddressError = false;

    return true;
  }


  validatePassengerCount(event: any) {
    const value = event.target.value;
    const cleanValue = value.replace(/\D/g, '');
    const singleDigit = cleanValue.slice(0, 1);
    if (singleDigit === '') {
      this.userDetails.passengersCount = null;
      event.target.value = '';
      return;
    }
    let finalValue = parseInt(singleDigit);
    if (finalValue > 7) {
      finalValue = 7;
    }
    this.userDetails.passengersCount = finalValue;
    event.target.value = finalValue.toString();
  }

  onFieldChange(fieldName: string) {
    switch (fieldName) {
      case 'name':
        if (this.userDetails.name && this.userDetails.name.trim() !== '') {
          this.showNameError = false;
        }
        break;
      case 'mobileNumber':
        if (this.userDetails.mobileNumber && this.userDetails.mobileNumber.trim() !== '') {
          this.showMobileError = false;
        }
        break;
      case 'passengersCount':
        if (this.userDetails.passengersCount && this.userDetails.passengersCount > 0 && this.userDetails.passengersCount <= 7) {
          this.showPassengerCountError = false;
        }
        break;
      case 'Address':
        if (this.userDetails.Address && this.userDetails.Address.trim() !== '') {
          this.showPickupAddressError = false;
        }
        break;
      case 'dropAddress':
        if (this.userDetails.dropAddress && this.userDetails.dropAddress.trim() !== '') {
          this.showDropAddressError = false;
        }
        break;
      case 'gstNumber':
        if (this.userDetails.gstNumber && this.userDetails.gstNumber.trim() !== '' && this.validateGstNumber(this.userDetails.gstNumber)) {
          this.showGstNumberError = false;
        }
        break;
    }
  }

 
  onCharacterOnlyInput(event: KeyboardEvent): boolean {
    const char = String.fromCharCode(event.which);
    const pattern = /^[a-zA-Z\s]+$/;
    
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}
